/**
 * This module handles selecting the per-page option from the pagination dropdown.
 */
var $ = require('jQuery');

var updateURLParameter = function(url, param, paramVal, ignore){
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var currentParam = "";
    var temp = "";

    if (additionalURL) {
        tempArray = additionalURL.split("&");

        for (i = 0; i < tempArray.length; i++) {
            currentParam = tempArray[i].split('=')[0];

            if (currentParam == param || currentParam == ignore) {
                continue;
            }

            newAdditionalURL += temp + tempArray[i];
            temp = "&";
        }
    }

    var rows_txt = temp + "" + param + "=" + paramVal;

    return newAdditionalURL + rows_txt;
};

$('.content').on("change", ".per-page", function(e) {
    var data = updateURLParameter(window.location.href, 'per_page', $(this).val(), 'page');

    $.pjax({url: window.location.href.split('?')[0], data: data, container: '#pjaxContainer', method: 'GET'});
});
